function getMaterialImage(configurationName, images) {
  return images[configurationName] || ''
}

module.exports = {
  getMaterialImage
}
